import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import axios from "axios"
// Register Service Worker
export const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then(registration => {
          console.log(
            "Service Worker registered with scope:",
            registration.scope
          )
        })
        .catch(error => {
          console.error("Service Worker registration failed:", error)
        })
    })
  }
}

// Call this function in your app's entry point
registerServiceWorker()

import store from "./store"
// axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL
// axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL
const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
)
window.addEventListener("load", () => {
  const loader = document.getElementById("global-loader");
  if (loader) {
    loader.style.display = "none";
  }
});

serviceWorker.unregister()
